import IconOther from '@src/assets/images/common/icon/files/icon-other.svg';
import IconPdf from '@src/assets/images/common/icon/files/icon-pdf.svg';
import IconPptx from '@src/assets/images/common/icon/files/icon-pptx.svg';
import IconImage from '@src/assets/images/common/icon/files/icon-svg.svg';
import IconWord from '@src/assets/images/common/icon/files/icon-word.svg';
import IconXlsx from '@src/assets/images/common/icon/files/icon-xlsx.svg';

const CHAT_ATTACHABLE_FILE_EXTENSION_CLASSIFICATION = {
  VIEWABLE_FILES: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif'],
  SPECIFIC_ICON_FILES: ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'txt', 'svg'],
  GENERIC_ICON_FILES: ['zip', 'rar', 'csv', 'json'],
};

const CHAT_ATTACHABLE_FILE_EXTENSION = {
  JPG: 'jpg',
  JPEG: 'jpeg',
  PNG: 'png',
  GIF: 'gif',
  WEBP: 'webp',
  SVG: 'svg',
  PDF: 'pdf',
  DOC: 'doc',
  DOCX: 'docx',
  PPT: 'ppt',
  PPTX: 'pptx',
  XLS: 'xls',
  XLSX: 'xlsx',
  TXT: 'txt',
  ZIP: 'zip',
  RAR: 'rar',
  CSV: 'csv',
  JSON: 'json',
};

const extensionIconMap: Record<string, string> = {
  [CHAT_ATTACHABLE_FILE_EXTENSION.JPG]: IconImage,
  [CHAT_ATTACHABLE_FILE_EXTENSION.JPEG]: IconImage,
  [CHAT_ATTACHABLE_FILE_EXTENSION.PNG]: IconImage,
  [CHAT_ATTACHABLE_FILE_EXTENSION.GIF]: IconImage,
  [CHAT_ATTACHABLE_FILE_EXTENSION.WEBP]: IconImage,
  [CHAT_ATTACHABLE_FILE_EXTENSION.SVG]: IconImage,

  [CHAT_ATTACHABLE_FILE_EXTENSION.PDF]: IconPdf,
  [CHAT_ATTACHABLE_FILE_EXTENSION.PPT]: IconPptx,
  [CHAT_ATTACHABLE_FILE_EXTENSION.PPTX]: IconPptx,
  [CHAT_ATTACHABLE_FILE_EXTENSION.DOC]: IconWord,
  [CHAT_ATTACHABLE_FILE_EXTENSION.DOCX]: IconWord,
  [CHAT_ATTACHABLE_FILE_EXTENSION.XLS]: IconXlsx,
  [CHAT_ATTACHABLE_FILE_EXTENSION.XLSX]: IconXlsx,
};

const fetchIcon = (extension: string): string => {
  return extensionIconMap[extension] || IconOther;
};

export { CHAT_ATTACHABLE_FILE_EXTENSION, CHAT_ATTACHABLE_FILE_EXTENSION_CLASSIFICATION, fetchIcon };
